"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSvg = require("react-svg");
require("./Availability.scss");
var Availability = function Availability(_ref) {
  var labels = _ref.labels,
    description = _ref.description,
    descriptions = _ref.descriptions,
    icon = _ref.icon,
    elementLocator = _ref.elementLocator,
    className = _ref.className;
  var pageName = window.location.pathname.split('/').pop();
  var availabilityClassName;
  if (descriptions) {
    availabilityClassName = pageName === 'order-confirmation' ? '' : 'availability-descriptions';
  } else {
    availabilityClassName = 'availability-description';
  }
  if (!labels) {
    availabilityClassName += pageName === 'order-confirmation' ? ' order-description' : ' description';
  }
  return _react.default.createElement("div", {
    className: "cmp-sku-details__availability " + className,
    "data-locator": "product-availability-container-" + elementLocator
  }, _react.default.createElement("span", {
    className: "availability-title",
    "data-locator": "availability-title"
  }, labels, icon && _react.default.createElement(_reactSvg.ReactSVG, {
    className: "availability-icon",
    src: icon
  })), _react.default.createElement("div", {
    className: availabilityClassName,
    "data-locator": "availability-description"
  }, description || ''), descriptions && _react.default.createElement("div", {
    className: availabilityClassName,
    "data-locator": "availability-description"
  }, descriptions || ''));
};
Availability.defaultProps = {
  labels: '',
  description: '',
  icon: '',
  elementLocator: '',
  className: ''
};
var _default = Availability;
exports.default = _default;
module.exports = exports["default"];